import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { FEATURE_FLAG } from '~/constants';

import { RouteExportParams } from '~/types/router.type';

import { ScanDetailPage } from '~/modules/deliveryScans';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { scansSearchDefaults, zodScansSearchSchema } from '../-searchParams';

const title = i18n.t(($) => $.pageTitle, { ns: 'deliveryScans' });

const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
  featureFlag: FEATURE_FLAG.DLN_LIST_V2,
};

export const Route = createFileRoute('/(main)/deliveries/scans/$scanId/')({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/scans/$scanId/',
    ...routeParams,
  }),
  component: ScanDetailPage,
  head: () => getRouteHead(title),
  remountDeps: ({ params }) => [params.scanId],
  search: {
    middlewares: [stripSearchParams(scansSearchDefaults)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodScansSearchSchema,
  wrapInSuspense: true,
});

export const DELIVERY_SCAN_DETAIL = buildRouteExport({
  Route,
  ...routeParams,
});
